import Vue from 'vue'

import MITOFC from './mito'

import {
  Title,
  Backtop,
  NotData,
  TreeTable,
  LevelSetModal
} from '../components'
//注册全局title组件
Vue.component('Title', Title)

//注册全局backtop组件
Vue.component('Backtop', Backtop)

//注册全局没数据组件
Vue.component('NotData', NotData)

//注册全局TreeTable组件
Vue.component('TreeTable', TreeTable)
//注册全局LevelSetModal组件
Vue.component('LevelSetModal', LevelSetModal)

if (window.__POWERED_BY_QIANKUN__) {
  /* eslint-disable */
  __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__
  /* eslint-enable */
}

//注册监控
export const initFc = keyName => {
  MITOFC(Vue, keyName)
}
